import "./Login.css";
import logo from "./assets/ab.jpg";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import apiClient from "./utils/apiClient";
import { saveUserSession } from "./utils/cryptoUtils";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [modal, setModal] = useState({
    show: false,
    type: "", // success | error
    message: "",
  });

  const navigate = useNavigate();

  const closeModal = () => {
    setModal({ show: false, type: "", message: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiClient("/auth/login/", {
        method: "POST",
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          password,
        }),
      });

      if (response?.access) {
        saveUserSession(response);

        setModal({
          show: true,
          type: "success",
          message: "Login successful. Redirecting...",
        });

        setTimeout(() => {
          navigate("/dashboard");
        }, 1200);
      } else {
        setModal({
          show: true,
          type: "error",
          message: "Invalid email or password",
        });
      }
    } catch (err) {
      const errorMessage =
        err?.data?.detail ||
        err?.data?.message ||
        "Invalid email or password";

      setModal({
        show: true,
        type: "error",
        message: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ================= MODAL ================= */}
      {modal.show && (
        <div className="modal-overlay">
          <div className={`modal-box ${modal.type}`}>
            <h3>{modal.type === "success" ? "Success" : "Error"}</h3>
            <p>{modal.message}</p>
            <button className="modal-btn" onClick={closeModal}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* ================= LOGIN UI ================= */}
      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-logo">
            <img src={logo} alt="Logo" />
          </div>

          <h1>Welcome Back 👋</h1>
          <p className="subtitle">Sign in to continue</p>

          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email"
              required
              disabled={loading}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="password"
              placeholder="Password"
              required
              disabled={loading}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>

          <Link to="/forgotpassword" className="forgot-password">
            Forgot Password?
          </Link>
        </div>
      </div>
    </>
  );
}

export default Login;
